import {
  Text,
  VStack,
  Box,
  Divider,
  HStack,
  Image,
  Center,
} from '@chakra-ui/react';

import { Task } from '../../../models';
import { taskStatusMapper } from '../utils';
import { extractName, transformDate } from '../../../utils';
import { TaskStatusBadge } from '.';

export const TaskDetail = ({
  task: {
    formName,
    status,
    workflowName,
    projectName,
    phaseName,
    modifiedBy,
    modifiedAt,
    createdAt,
    createdBy,
    isLate,
    formFieldAnswers,
  },
  userPreferenceData,
}: {
  task: Task;
  userPreferenceData?: {
    id?: number;
    formTemplateId?: number;
    tempFormId?: number;
    field: string;
  }[];
}) => {
  const receivedAt = modifiedAt ?? createdAt;
  const receivedFrom = modifiedBy ?? createdBy;

  const getFieldText = (customCol: any) => {
    const targetField = formFieldAnswers?.find(
      answer => answer.title === customCol.field
    );
    if (targetField) {
      return targetField.answer;
    } else {
      return '-';
    }
  };

  return (
    <HStack
      display="flex"
      flexDirection="row"
      minWidth="max-content" // Ensure the content respects its width
      marginTop={"8px"}
    >
      <HStack
        position="sticky"
        left="0" // Sticks to the left during scroll
        zIndex="10" // Ensures it stays above other elements
        height="76px"
        background="white"
        width={"250px"}
      >
        <HStack
          height="76px"
          borderRadius="8px"
          border="1px solid #BCBEC066"
          background={"white"}
          boxShadow="0px 0px 15px -15px rgba(0, 0, 0, 0.1)"
        >
          <VStack w="250px" gap="0" display={"flex"} justifyContent={"center"} alignItems={"center"} >
            <Box w="80%">
              <TaskStatusBadge status={status} isLate={isLate} />
            </Box>
          </VStack>
        </HStack>
      </HStack>

    <HStack
      style={{height: "60px",borderRadius:"8px", marginLeft: "16px", marginRight: "16px"}}
      px="2"
      py="2"
      borderRadius="8px"
      w="auto"
      height={"76px"}
      border="1px solid #BCBEC066"
    >
      <HStack w="250px" maxW="250px" px={"16px"}>
        <Image src={taskStatusMapper(status, isLate)} />
        <VStack align="start" gap="0">
          <Text fontSize="md" fontWeight="500" flexWrap={"wrap"} >
            {formName}
          </Text>
        </VStack>
      </HStack>

      <VStack w="200px" maxW="200px" align="start" gap="0">
      <Text fontSize="md" fontWeight="500" color="#6C707A">
        {workflowName}
      </Text>
      </VStack>

      <VStack w="200px" maxW="200px" align="start" gap="0">
        <Text   fontSize="md" fontWeight="500" color="#6C707A">
            {projectName}
        </Text>
        {phaseName && !phaseName.includes('DEFAULT_PHASE') && (
          <Text fontSize="md" fontWeight="500">
            <Box as="span" color="#6C707A">
              {phaseName}
            </Box>
          </Text>
        )}
      </VStack>

      {receivedFrom && (
        <HStack w="250px" maxW="250px" justify="space-between">
          <HStack gap="4" w="full">
            <VStack align="flex-start" gap="0">
              <Text fontSize="lg" color="#101828">{receivedFrom?.partner?.name}</Text>
              <Text color="#6C707A" fontWeight="500" fontSize="sm">
                {receivedFrom.firstName} {receivedFrom.lastName}
              </Text>
            </VStack>
          </HStack>
        </HStack>
      )}

      {receivedAt && (
        <Box w="250px" maxW="250px" fontSize="md">
          <Box as="span" color="#6C707A" textDecoration={"underline"}>
            {transformDate(receivedAt)}
          </Box>
        </Box>
      )}

      {userPreferenceData?.map(customCol => (
        <VStack key={customCol.id} w="200px" maxW="200px" align="start" gap="0">
          <Text fontSize="md">
            <Box as="span" color="#6C707A">
              {getFieldText(customCol)}
            </Box>
          </Text>
        </VStack>
      ))}

    </HStack>
    </HStack>
  );
};
